import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback } from '@redneckz/uni-jsx/lib/hooks';
import { useNormalizedInput } from '../../hooks/useNormalizedInput.js';
import { clamp } from '../../utils/clamp.js';
import { toLocalNumberFormat } from '../../utils/toLocalNumberFormat.js';
import { Input } from '../Input/Input.js';
export const NumberInput = JSX((props) => {
    const { onChange, min, max, defaultValue = '0', fractionDigits = 0, ...inputProps } = props;
    const normalizedProps = useNormalizedInput(props, {
        normalize: (_ = defaultValue) => min && max ? String(clamp(Number(sanitizeNumberStr(_)), min, max)) : sanitizeNumberStr(_),
        format: toLocalNumberFormat(fractionDigits),
    });
    const handleChange = useCallback((_) => onChange && onChange(sanitizeNumberStr(_)), [onChange]);
    return _jsx(Input, { onChange: handleChange, ...inputProps, ...normalizedProps });
});
const sanitizeNumberStr = (_ = '') => _.replaceAll(',', '.')
    .replace(/[^\d.]/g, '')
    .replace(/([^.]*\.[^.]*)\./, '$1');
//# sourceMappingURL=NumberInput.js.map